import { render, staticRenderFns } from "./roleMenuAuth.vue?vue&type=template&id=703f9d21&scoped=true"
import script from "./roleMenuAuth.vue?vue&type=script&lang=js"
export * from "./roleMenuAuth.vue?vue&type=script&lang=js"
import style0 from "./roleMenuAuth.vue?vue&type=style&index=0&id=703f9d21&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f9d21",
  null
  
)

export default component.exports